import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    name: 'Michael R.',
    role: t.test.roles.homeowner,
    text: t.test.t1,
    stars: 5
  }, {
    name: 'Sarah T.',
    role: t.test.roles.business,
    text: t.test.t2,
    stars: 5
  }, {
    name: 'David L.',
    role: t.test.roles.investor,
    text: t.test.t3,
    stars: 5
  }];
  return <section id="testimonials" className="py-24 relative overflow-hidden" data-id="element-250">
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/bQnrYKEbFbq7Ys2ZfsDfvf/_Flood_20170914165447_ZQ.jpg")'
    }} data-id="element-251" />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/95 to-gray-900" data-id="element-252" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-254">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-gold font-bold tracking-wider uppercase mb-2" data-id="element-255">
            {t.test.tag}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-256">
            {t.test.title}
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-257">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm border border-white/10 p-8 rounded-sm relative" data-id="element-258">
              <Quote className="absolute top-6 right-6 text-white/5" size={60} data-id="element-259" />
              <div className="flex gap-1 mb-6 relative z-10" data-id="element-260">
                {[...Array(testimonial.stars)].map((_, i) => <Star key={i} className="text-brand-gold fill-brand-gold" size={20} data-id="element-261" />)}
              </div>
              <p className="text-gray-300 italic mb-6 relative z-10 leading-relaxed" data-id="element-262">
                "{testimonial.text}"
              </p>
              <div className="relative z-10 border-t border-white/10 pt-4" data-id="element-263">
                <div className="font-bold text-white text-lg" data-id="element-264">
                  {testimonial.name}
                </div>
                <div className="text-sm text-brand-gold font-medium uppercase tracking-wider" data-id="element-265">
                  {testimonial.role}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}